import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./Footer.scss";
import { Container } from "reactstrap";
import { getLang } from "../../utilties/Utils";
class Footer extends React.Component {
  render() {
    return (
      <Container className="footer p-2 m-0">
        {/*<span className="terms text-dark d-none d-sm-inline">*/}
        {this.props.clientInfo &&
          this.props.clientInfo.links &&
          this.props.clientInfo.links.termsAndCondition &&
          !!this.props.clientInfo.links.termsAndCondition.visible && (
            <span
              dangerouslySetInnerHTML={{
                __html: getLang(
                  this.props.clientInfo.links.termsAndCondition.text
                )
              }}
              className="terms text-dark"
            ></span>
          )}
        {this.props.clientInfo &&
          this.props.clientInfo.links &&
          this.props.clientInfo.links.poweredBy &&
          !!this.props.clientInfo.links.poweredBy.visible && (
            <span
              dangerouslySetInnerHTML={{
                __html: getLang(this.props.clientInfo.links.poweredBy.text)
              }}
              className="ee-link text-dark"
            ></span>
          )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  clientInfo: state.appDataReducer && state.appDataReducer.clientInfo
});

const FooterComponentConnected = withRouter(
  connect(mapStateToProps, {})(Footer)
);

export { FooterComponentConnected as default };
